"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matrixReducer = exports.normalizeDateItems = exports.maxDate = exports.minDate = exports.timeSorter = exports.weekDayLabel = exports.getWeekNumber = exports.parseDatetime = exports.parseDate = exports.hourBegin = exports.hour = exports.calendarStringTime = exports.formatDatetime = exports.formatDate = exports.dbDatetime = exports.asStringDatetime = exports.asString = exports.pad = exports.monthName = exports.listUntil = exports.weekBoundaryLabel = exports.weekBoundary = exports.nextSaturday = exports.prevSunday = exports.prevYear = exports.nextYear = exports.prevMonth = exports.nextMonth = exports.lastDayOfMonth = exports.firstDayOfMonth = exports.prev = exports.next = exports.cloneDateTime = exports.cloneDate = void 0;
function cloneDate(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
exports.cloneDate = cloneDate;
function cloneDateTime(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
}
exports.cloneDateTime = cloneDateTime;
function next(date) {
    let result = cloneDate(date);
    result.setDate(result.getDate() + 1);
    return result;
}
exports.next = next;
function prev(date) {
    let result = cloneDate(date);
    result.setDate(result.getDate() - 1);
    return result;
}
exports.prev = prev;
function firstDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
exports.firstDayOfMonth = firstDayOfMonth;
function lastDayOfMonth(date) {
    let result = nextMonth(date);
    result.setDate(0);
    return result;
}
exports.lastDayOfMonth = lastDayOfMonth;
function nextMonth(date) {
    let result = cloneDate(date);
    result.setDate(1);
    result.setMonth(result.getMonth() + 1);
    return result;
}
exports.nextMonth = nextMonth;
function prevMonth(date) {
    let result = firstDayOfMonth(date);
    result.setDate(0);
    result.setDate(1);
    return result;
}
exports.prevMonth = prevMonth;
function nextYear(date) {
    let result = new Date(date.getFullYear() + 1, 0, 1);
    return result;
}
exports.nextYear = nextYear;
function prevYear(date) {
    let result = new Date(date.getFullYear() - 1, 0, 1);
    return result;
}
exports.prevYear = prevYear;
function prevSunday(date) {
    let result = cloneDate(date);
    if (result.getDay() == 0)
        return result;
    result.setDate(result.getDate() - result.getDay());
    return result;
}
exports.prevSunday = prevSunday;
function nextSaturday(date) {
    let result = cloneDate(date);
    if (result.getDay() == 6)
        return result;
    result.setDate(result.getDate() + 6 - result.getDay());
    return result;
}
exports.nextSaturday = nextSaturday;
function weekBoundary(date) {
    var start = prevSunday(date);
    var end = nextSaturday(date);
    var days = listUntil(start, (d) => d.getTime() <= end.getTime());
    return { start, end, days, selected: date };
}
exports.weekBoundary = weekBoundary;
function weekBoundaryLabel(date) {
    var start = prevSunday(date);
    var end = nextSaturday(date);
    if (start.getMonth() != end.getMonth())
        return `${start.getDate()} de ${monthName(start, true)} - ${end.getDate()} de ${monthName(end, true)}`;
    return `${start.getDate()} a  ${end.getDate()} de ${monthName(start)}`;
}
exports.weekBoundaryLabel = weekBoundaryLabel;
function listUntil(date, ok) {
    date = cloneDate(date);
    var result = [];
    while (ok(date)) {
        result.push(date);
        date = next(date);
    }
    return result;
}
exports.listUntil = listUntil;
function monthName(date, short = false) {
    let names = 'janeiro,fevereiro,março,abril,maio,junho,julho,agosto,setembro,outubro,novembro,dezembro'.split(",");
    if (short)
        return names[date.getMonth()].substring(0, 3);
    return names[date.getMonth()];
}
exports.monthName = monthName;
function pad(n) {
    if (n < 10)
        return "0" + n;
    return n;
}
exports.pad = pad;
function asString(date) {
    return `${pad(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
exports.asString = asString;
function asStringDatetime(date) {
    return `${pad(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${hour(date)}`;
}
exports.asStringDatetime = asStringDatetime;
function dbDatetime(date) {
    if (!date)
        return null;
    return `${pad(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${hour(date)}${pad(date.getSeconds())}`;
}
exports.dbDatetime = dbDatetime;
function formatDate(date) {
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${pad(date.getFullYear())}`;
}
exports.formatDate = formatDate;
function formatDatetime(date) {
    if (date == null)
        return "";
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${pad(date.getFullYear())} - ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
exports.formatDatetime = formatDatetime;
function calendarStringTime(date) {
    return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}T${pad(date.getHours())}${pad(date.getMinutes())}00`;
}
exports.calendarStringTime = calendarStringTime;
function hour(date) {
    return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
exports.hour = hour;
function hourBegin(date) {
    return `${pad(date.getHours())}:00`;
}
exports.hourBegin = hourBegin;
function parseDate(str) {
    if (!str)
        return null;
    var m = null;
    if (str.length == 10) {
        m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!m)
            return null;
        return new Date(parseInt(m[1]), parseInt(m[2]) - 1, parseInt(m[3]));
    }
    m = str.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})/);
    if (!m)
        return null;
    return new Date(parseInt(m[1]), parseInt(m[2]) - 1, parseInt(m[3]), parseInt(m[4]), parseInt(m[5]));
}
exports.parseDate = parseDate;
function parseDatetime(str) {
    var matches = str.match(/^(\d{2})\/(\d{2})\/(\d{4}) - (\d{2}):(\d{2})$/);
    if (!matches)
        return null;
    return parseDate(str.replace(/^(\d{2})\/(\d{2})\/(\d{4}) - (\d{2}):(\d{2})$/, "$3-$2-$1 $4:$5"));
}
exports.parseDatetime = parseDatetime;
function getWeekNumber(date) {
    if (date == null)
        0;
    var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    var dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
}
exports.getWeekNumber = getWeekNumber;
function weekDayLabel(date) {
    if (!date)
        return "";
    let days = "domingo,segunda-feira,terça-feira,quarta-feira,quinta-feira,sexta-feira,sábado".split(/,/);
    return days[date.getDay()];
}
exports.weekDayLabel = weekDayLabel;
function timeSorter(getter) {
    return function (a, b) {
        var timeA = getter(a);
        var timeB = getter(b);
        if (timeA != null && timeB != null)
            return timeA.getTime() - timeB.getTime();
        if (timeA != null)
            return timeA.getTime();
        if (timeB != null)
            return timeB.getTime();
        return 0;
    };
}
exports.timeSorter = timeSorter;
function minDate(items, getDate) {
    var result = null;
    for (let i of items) {
        let date = getDate(i);
        if (result == null) {
            result = date;
            continue;
        }
        if (date.getTime() < result.getTime())
            result = date;
    }
    return result;
}
exports.minDate = minDate;
function maxDate(items, getDate) {
    var result = null;
    for (let i of items) {
        let date = getDate(i);
        if (result == null) {
            result = date;
            continue;
        }
        if (date.getTime() > result.getTime())
            result = date;
    }
    return result;
}
exports.maxDate = maxDate;
function normalizeDateItems(items, getDate, factory) {
    if (items.length < 2)
        return items;
    const min = minDate(items, getDate);
    const max = maxDate(items, getDate);
    const dates = listUntil(min, d => d.getTime() <= max.getTime());
    return dates.map(a => {
        var item = items.find(i => getDate(i).getTime() == a.getTime());
        if (item == null)
            return factory(a);
        return item;
    });
}
exports.normalizeDateItems = normalizeDateItems;
function matrixReducer(rows, getDate, factory, reducer) {
    const temp = {};
    for (let row of rows) {
        for (let item of row) {
            let date = getDate(item);
            let key = asString(date);
            let current = temp[key];
            if (!current) {
                temp[key] = factory(item);
            }
            else
                temp[key] = reducer(current, item);
        }
    }
    const result = Object.values(temp);
    result.sort((a, b) => getDate(a).getTime() - getDate(b).getTime());
    return result;
}
exports.matrixReducer = matrixReducer;
//# sourceMappingURL=date-utils.js.map